// Patch cart.js for NP custom theme.
// Removes Dawn-specific section dependencies (cart-icon-bubble, cart-live-region-text)
// that don't exist in our custom header, and guards against null section HTML.

// Fix quantity button clicks — Dawn's QuantityInput uses event.target.name which breaks
// when the click lands on a child SVG element rather than the button itself.
// Intercept at capture phase and resolve the correct button via closest().
document.addEventListener('click', function (e) {
  var btn = e.target.closest && e.target.closest('quantity-input button');
  if (!btn) return;
  var qi = btn.closest('quantity-input');
  if (!qi) return;
  var input = qi.querySelector('.quantity__input');
  if (!input) return;
  e.stopImmediatePropagation();
  var prev = input.value;
  if (btn.getAttribute('name') === 'plus') {
    input.stepUp();
  } else {
    input.stepDown();
  }
  if (prev !== input.value) {
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}, true);

// Inline remove confirmation — intercepts the click, shows custom Yes/No UI on the item row.
document.addEventListener('click', function (e) {
  var removeBtn = e.target.closest && e.target.closest('cart-remove-button');
  if (!removeBtn) return;

  // If this click was confirmed by the Yes button, let it through to Dawn's handler
  if (removeBtn._npConfirmed) { removeBtn._npConfirmed = false; return; }

  e.stopImmediatePropagation();
  e.preventDefault();

  var cartItem = removeBtn.closest('.np-cart__item');
  if (!cartItem) return;
  if (cartItem.querySelector('.np-cart__confirm')) return; // already showing

  var actions = cartItem.querySelector('.np-cart__item-actions');
  var right   = cartItem.querySelector('.np-cart__item-right');
  if (!right) return;

  if (actions) actions.style.display = 'none';

  var confirmEl = document.createElement('div');
  confirmEl.className = 'np-cart__confirm';
  confirmEl.innerHTML =
    '<span class="np-cart__confirm-text">Are you sure?</span>' +
    '<button class="np-cart__confirm-yes" type="button">Yes</button>' +
    '<button class="np-cart__confirm-no"  type="button">No</button>';
  right.appendChild(confirmEl);

  confirmEl.querySelector('.np-cart__confirm-yes').addEventListener('click', function () {
    confirmEl.remove();
    if (actions) actions.style.display = '';
    removeBtn._npConfirmed = true;
    removeBtn.click();
  });

  confirmEl.querySelector('.np-cart__confirm-no').addEventListener('click', function () {
    confirmEl.remove();
    if (actions) actions.style.display = '';
  });
}, true);

(function () {
  var CartItemsClass = customElements.get('cart-items');
  if (!CartItemsClass) return;

  var origGetSections = CartItemsClass.prototype.getSectionsToRender;
  CartItemsClass.prototype.getSectionsToRender = function () {
    return origGetSections.call(this).filter(function (s) {
      return document.getElementById(s.id) !== null;
    });
  };

  var origGetInnerHTML = CartItemsClass.prototype.getSectionInnerHTML;
  CartItemsClass.prototype.getSectionInnerHTML = function (html, selector) {
    if (!html) return '';
    return origGetInnerHTML.call(this, html, selector);
  };
})();
